<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
				<FormItem label="合同编号" prop="contractCode" class="sj">
					<Input v-model="formValidate.contractCode" placeholder="请输入合同编号"></Input>
				</FormItem>
				<FormItem label="总金额" prop="money" class="sj">
					<Input v-model="formValidate.money" placeholder="请输入总价"></Input>
				</FormItem>
				<FormItem label="加盟商" prop="allianceId" class="sj">
					<Select v-model="formValidate.allianceId" placeholder="请选择类型加盟商" @on-change="onchange">
						<Option v-for="(item,i) in alliances" :key="i"  :value="item.id" >{{item.companyName}}</Option>
						
					</Select>
				</FormItem>
				<FormItem label="责任人" prop="dutyEmpId" class="sj">
					<Select v-model="formValidate.dutyEmpId" placeholder="请选择责任人">
						<Option v-for="(item,i) in emps" :key="i"  :value="item.id" >{{item.name}}</Option>
						
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				loading:false,
				formValidate: {
					contractCode: '',
					money: '',
					allianceId: '',
					dutyEmpId:''
				},
				alliances:[],
				emps:[],
				ruleValidate: {
					contractCode: [{
						required: true,
						message: '合同编号不能为空！！！',
						trigger: 'blur'
					}],
					money: [{
						required: true,
						message: '总价不能为空！！！',
						trigger: 'blur'
					}],
					allianceId: [{
						required: true,
						message: '请选择加盟商！！！',
						trigger: 'blur'
					}],
					dutyEmpId: [{
						required: true,
						message: '请选择责任人！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() {//返回上一页
				this.$router.go(-1)
			},
			onchange(allianceId){
				let _this=this
				let regionId=null
				for (let i = 0; i < _this.alliances.length; i++) {
					let a=_this.alliances[i]
					if(a.id==allianceId){
						regionId=a.region.id
					}
				}
				_this.ajaxEmp(regionId)
			},
			handleSubmit (name) {
				 let _this=this
                this.$refs[name].validate((valid) => {
                    if (valid) {
						if(escape(this.formValidate.contractCode).indexOf("%u")>=0){
							_this.$Message.error('订单号不能包含中文!');
						   return ;
						}
						let aa={
							contractCode: this.formValidate.contractCode,
							money: this.formValidate.money*100,
							allianceId: this.formValidate.allianceId,
							dutyEmpId:this.formValidate.dutyEmpId
						}
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/fin/report/contract/add',
						    data: aa,
							_this: _this,
							success: function(data) {
								_this.$Message.success('新增成功!');
								_this.$refs[name].resetFields();
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
                    } else {
                        this.$Message.error('请完善信息后再进行提交!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
			queryAlliance(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/alliance/page1',
				    data: {page:0,size:1000},
					_this: _this,
					success: function(data) {
						_this.alliances=data.alliances.content
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				 
			},
			ajaxEmp(regionId) {
				let aa= { //查询参数
					page: 0,
					size: 100,
					jmType:'FACILITY',
					like:'',
					regionId:regionId
				}
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/jm/emp/page',
				    data: aa,
					_this: _this,
					success: function(data) {
						_this.emps = data.empPage.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
			
		},
		created(){
			let _this=this
			_this.queryAlliance()
			_this.ajaxEmp(null)
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/macOrder/add.vue